/**
 * Notification Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

import Button from '../../../atoms/buttons/Button';
import { IconCheck, IconWarning, IconX } from '../../../atoms/images/Icon';
import Thumbnail from '../../../atoms/images/Thumbnail';
import { Span } from '../../../atoms/text/Label';

interface IOwnState {
  autoOpen: boolean | undefined;
  open: boolean | undefined;
}

const classes = new BEM('notification');
export default class Notification extends React.Component<INotificationProps, IOwnState> {
  static defaultProps = {
    action: 'close',
    autoDismiss: 4000,
    state: 'info',
  };

  private autoHideTimer;
  private isReady = false;

  constructor(props: INotificationProps) {
    super(props);

    this.state = {
      autoOpen: this.props.open,
      open: false,
    };
  }

  componentWillReceiveProps({ open }: INotificationProps) {
    if (this.isReady && this.state.open !== open) {
      this.setState({ open });
    }
  }

  componentDidMount() {
    if (this.state.autoOpen) {
      setTimeout(() => {
        this.setState({ open: true });
        this.isReady = true;
      }, 100);
    }
  }

  onActionClick = () => {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
      this.autoHideTimer = undefined;
    }

    if (this.props.onActionClick) {
      this.props.onActionClick();
    }

    this.onDismiss();
  }

  onDismiss = () => {
    if (this.props.onRequestClose) {
      this.props.onRequestClose('click');
    } else {
      this.setState({ open: false });
    }
  }

  render() {
    const {
      action,
      autoDismiss,
      image,
      message,
      state,
    } = this.props;

    const { open } = this.state;

    const modifiers = {
      'open': !!open,
      [state!]: !!state!,
      'custom-action': action !== 'close',
      'xsmall': message.length > 140,
    };

    if (open && (autoDismiss && !!autoDismiss)) {
      this.startAutoHide();
    }

    return (
      <div {...classes('', modifiers) }>
        <div {...classes('content') }>
          {image ? (
            <Thumbnail src={image} size="small" withShadow />
          ) : state === 'error' && <IconWarning {...classes('context-icon') } />}
          <Span {...classes('message') } variant="description" text={message} />
          {action === 'close' ? (
            <Button
              onClick={this.onActionClick}
              variant="icon"
              icon={state !== 'success' ? <IconX /> : <IconCheck />}
              size="small"
              {...classes('action') }
            />
          ) : (
              <Button onClick={this.onActionClick} label={action} size="medium" {...classes('action') } />
            )}
        </div>
      </div>
    );
  }

  private startAutoHide() {
    if (this.autoHideTimer) {
      return;
    }

    this.autoHideTimer = setTimeout(() => {
      clearTimeout(this.autoHideTimer);
      this.autoHideTimer = undefined;
      this.onDismiss();
    }, this.props.autoDismiss as number);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/messaging/Notification/index.tsx